import { render } from "./messaging-service-configuration-form-message-information-section.vue?vue&type=template&id=4816c8f7&scoped=true&ts=true"
import script from "./messaging-service-configuration-form-message-information-section.vue?vue&type=script&lang=ts"
export * from "./messaging-service-configuration-form-message-information-section.vue?vue&type=script&lang=ts"

import "./messaging-service-configuration-form-message-information-section.vue?vue&type=style&index=0&id=4816c8f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4816c8f7"]])

export default __exports__